import { GAUSSIAN_EXP_FACTOR } from '../../../util/constants';
import { Gaussian } from '../../1d/gaussian/Gaussian';
import { Shape2DClass } from '../Shape2DClass';
export class Gaussian2D extends Shape2DClass {
    // /**
    //  * The maximum z value of the shape, default keep surface equal 1.
    //  */
    // public height: number;
    constructor(options = {}) {
        super();
        let { fwhm = 50, sd } = options;
        fwhm = ensureFWHM2D(fwhm, sd);
        this.fwhmX = fwhm.x;
        this.fwhmY = fwhm.y;
    }
    fct(x, y) {
        return Gaussian2D.fct(x, y, this.fwhmX, this.fwhmY);
    }
    getData(options = {}) {
        return Gaussian2D.getData({
            fwhm: { x: this.fwhmX, y: this.fwhmY },
        }, options);
    }
    getFactor(surface) {
        return Gaussian.getFactor(surface);
    }
    getSurface(height = Gaussian2D.calculateHeight({
        fwhm: { x: this.fwhmY, y: this.fwhmY },
        surface: 1,
    })) {
        return Gaussian2D.getSurface({
            fwhm: { x: this.fwhmY, y: this.fwhmY },
            height,
        });
    }
    widthToFWHM(width) {
        return Gaussian.widthToFWHM(width);
    }
    fwhmToWidth(fwhm) {
        return Gaussian.fwhmToWidth(fwhm);
    }
    static getFactor(surface) {
        return Gaussian.getFactor(surface);
    }
    static widthToFWHM(width) {
        return Gaussian.widthToFWHM(width);
    }
    static fwhmToWidth(fwhm) {
        return Gaussian.fwhmToWidth(fwhm);
    }
    set fwhm(fwhm) {
        fwhm = ensureXYNumber(fwhm);
        this.fwhmX = fwhm.x;
        this.fwhmY = fwhm.y;
    }
    /**
     * Return a parameterized function of a Gaussian2D shape (see README for equation).
     * @param x - x value to calculate.
     * @param y - y value to calculate.
     * @param fwhmX - full width half maximum in the x axis.
     * @param fwhmY - full width half maximum in the y axis.
     * @returns - the z value of bi-dimensional gaussian with the current parameters.
     */
    static fct(x, y, xFWHM, yFWHM) {
        return Math.exp(GAUSSIAN_EXP_FACTOR * (Math.pow(x / xFWHM, 2) + Math.pow(y / yFWHM, 2)));
    }
    /**
     * Calculate the intensity matrix of a gaussian shape.
     * @returns z values.
     */
    static getData(shape, options = {}) {
        let { fwhm = 50, sd } = shape;
        fwhm = ensureFWHM2D(fwhm, sd);
        let { factor = Gaussian.getFactor(), length = { x: 0, y: 0 }, height = Gaussian2D.calculateHeight({ fwhm, surface: 1 }), } = options;
        factor = ensureXYNumber(factor);
        length = ensureXYNumber(length);
        for (const axis of ['x', 'y']) {
            if (!length[axis]) {
                length[axis] = Math.min(Math.ceil(fwhm[axis] * factor[axis]), Math.pow(2, 25) - 1);
                if (length[axis] % 2 === 0)
                    length[axis]++;
            }
        }
        const xCenter = (length.x - 1) / 2;
        const yCenter = (length.y - 1) / 2;
        const data = new Array(length.x);
        for (let i = 0; i < length.x; i++) {
            data[i] = new Float64Array(length.y);
        }
        for (let i = 0; i < length.x; i++) {
            for (let j = 0; j < length.y; j++) {
                data[i][j] =
                    Gaussian2D.fct(i - xCenter, j - yCenter, fwhm.x, fwhm.y) * height;
            }
        }
        return data;
    }
    static calculateHeight(options = {}) {
        let { surface = 1, fwhm = 1 } = options;
        fwhm = ensureXYNumber(fwhm);
        return (surface * Math.LN2 * 4) / (Math.PI * fwhm.y * fwhm.x);
    }
    static getSurface(options = {}) {
        let { fwhm = 50, height = 1 } = options;
        if (typeof fwhm !== 'object')
            fwhm = { x: fwhm, y: fwhm };
        return (height * Math.PI * fwhm.y * fwhm.x) / Math.LN2 / 4;
    }
}
function ensureXYNumber(input) {
    return typeof input !== 'object' ? { x: input, y: input } : { ...input };
}
function ensureFWHM2D(fwhm, sd) {
    if (sd !== undefined) {
        let sdObject = ensureXYNumber(sd);
        return {
            x: Gaussian.widthToFWHM(2 * sdObject.x),
            y: Gaussian.widthToFWHM(2 * sdObject.y),
        };
    }
    else if (fwhm !== undefined) {
        return ensureXYNumber(fwhm);
    }
    else {
        throw new Error('ensureFWHM2D must have either fwhm or sd defined');
    }
}
//# sourceMappingURL=Gaussian2D.js.map